import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { Input, Modal, Render, Select } from '../../../components';
import { AddWhite, DownloadIcon, KPI11Icon, KPI21Icon, KPI31Icon, KPI41Icon, KPI51Icon, KPI61Icon, KPI71Icon, SearchIcon } from '../../../assets/icons';
import { classNames, Constants, fromStorage, getUpdatedState, Socket, SocketEvents } from '../../../utils';
import { OrdersService } from '../../../services';
import ModalCreateOrder from './modal-create-order';
import ModalBulkCreateOrder from "./modal-bulk-create-order";
import ModalReassignment from "./modal-reassignment";

const COLUMN = {
  ALERT: 1,
  ACCEPTED: 2,
  CONFIRMED: 3,
  INITIATED: 4,
  FINISHED: 5,
}

const MODAL = {
  NONE: 1,
  CREATE: 2,
  BULK_CREATE: 3,
  EDIT: 4,
  REASSIGNMENT: 5,
}

const Panel = () => {
  const [modal, setModal] = useState(MODAL.NONE);
  const [editingItem, setEditingItem] = useState(null);
  const { data, filters, downloadAll, onChange, reload, search, selects } = useFetchTable();

  const onSelectItem = (modal, item = null) => {
    setEditingItem(item);
    setModal(modal);
  }

  return (
    <div>
      <Modal isOpen={modal === MODAL.CREATE} onClose={() => onSelectItem(MODAL.NONE)}>
        <ModalCreateOrder onClose={() => onSelectItem(MODAL.NONE)} onSuccess={reload} />
      </Modal>

      <Modal isOpen={modal === MODAL.EDIT} onClose={() => onSelectItem(MODAL.NONE)}>
        <ModalCreateOrder
          initialData={editingItem}
          onClose={() => onSelectItem(MODAL.NONE)}
          onSuccess={reload}
        />
      </Modal>

      <Modal isOpen={modal === MODAL.BULK_CREATE} onClose={() => onSelectItem(MODAL.NONE)}>
        <ModalBulkCreateOrder
          onClose={() => onSelectItem(MODAL.NONE)}
          onSuccess={reload}
        />
      </Modal>

      <Modal isOpen={modal === MODAL.REASSIGNMENT} onClose={() => onSelectItem(MODAL.NONE)}>
        <ModalReassignment
          item={editingItem}
          onClose={() => onSelectItem(MODAL.NONE)}
          onSuccess={reload}
        />
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="grid grid-cols-[1fr_1fr_1fr_1fr_1fr] items-center gap-3">
          <Input
            placeholder="Buscar"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Select
            placeholder="Estatus"
            items={selects.status}
            value={filters.status}
            onValueChange={v => onChange('status', v)}
          />

          <Input
            placeholder="Placa del vehículo"
            value={filters.plaque}
            onValueChange={v => onChange('plaque', v)}
          />

          <Input
            placeholder="Ruta"
            value={filters.route}
            onValueChange={v => onChange('route', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-end py-4 gap-4">
        <button onClick={() => onSelectItem(MODAL.BULK_CREATE)} className="flex items-center gap-2 bg-[#000] text-white px-4 py-1.5 rounded-lg font-semibold">
          Subida masiva de viajes en excel
        </button>

        <button onClick={() => onSelectItem(MODAL.CREATE)} className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold">
          <img src={AddWhite} className="w-4 h-4" alt="" />
          Nuevo
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-7 gap-2 mb-6">
        <KPICard
          icon={KPI11Icon}
          label="Total viajes programados"
          value={data.totals.scheduled}
        />
        <KPICard
          icon={KPI21Icon}
          label="Viajes aceptados"
          value={data.totals.accepted}
        />
        <KPICard
          icon={KPI31Icon}
          label="Viajes Iniciados"
          value={data.totals.initiated}
        />
        <KPICard
          icon={KPI41Icon}
          label="Viajes confirmados"
          value={data.totals.confirmed}
        />
        <KPICard
          icon={KPI51Icon}
          label="Viajes Finalizados"
          value={data.totals.finished}
        />
        <KPICard
          icon={KPI61Icon}
          label="Viajes en Alerta"
          value={data.totals.alerts}
        />
        <KPICard
          icon={KPI71Icon}
          label="% Cumplimiento del día"
          value={`${data.totals.kpi}%`}
        />
      </div>

      <div className="flex justify-between items-center mb-6 bg-white p-4 rounded-xl shadow-sm">
        <div className="flex items-center gap-3">
          <h2 className="text-lg font-bold text-black font-sans">Cartelera de viajes</h2>
          <button className="border border-orange text-orange bg-orange/10 font-bold px-3 py-1.5 rounded-full text-sm">HOY</button>
        </div>
        <button
          className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
          onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
        >
          <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
          Descargar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <div>
          <ColumnHeader column={COLUMN.ALERT} label="Alerta" total={data.alerts.length} />
          {data.alerts.map(item => (
            <Card
              key={item.id}
              item={item}
              column={COLUMN.ALERT}
              onReassign={() => onSelectItem(MODAL.REASSIGNMENT, item)}
            />
          ))}
        </div>

        <div>
          <ColumnHeader column={COLUMN.ACCEPTED} label="Aceptado" total={data.accepted.length} />
          {data.accepted.map(item => (
            <Card key={item.id} item={item} column={COLUMN.ACCEPTED} />
          ))}
        </div>

        <div>
          <ColumnHeader column={COLUMN.CONFIRMED} label="Confirmado" total={data.confirmed.length} />
          {data.confirmed.map(item => (
            <Card key={item.id} item={item} column={COLUMN.CONFIRMED} />
          ))}
        </div>

        <div>
          <ColumnHeader column={COLUMN.INITIATED} label="Iniciado" total={data.initiated.length} />
          {data.initiated.map(item => (
            <Card key={item.id} item={item} column={COLUMN.INITIATED} />
          ))}
        </div>

        <div>
          <ColumnHeader column={COLUMN.FINISHED} label="Finalizados" total={data.finished.length} />
          {data.finished.map(item => (
            <Card key={item.id} item={item} column={COLUMN.FINISHED} />
          ))}
        </div>

      </div>

      <Render condition={!data.totals.scheduled}>
        <p className="text-center text-default my-8">No se encontraron registros</p>
      </Render>
    </div>
  );
}

const KPICard = ({ icon, label, value }) => (
  <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray5 flex flex-col justify-between min-h-[100px]">
    <p className="text-sm font-bold text-black leading-tight">{ label }</p>
    <div className="flex gap-4 items-center">
      <img src={icon} className="w-8 h-8 object-contain" alt="" />
      <p className="text-3xl font-black text-black">{ value }</p>
    </div>
  </div>
)

const ColumnHeader = ({ column, label, total }) => (
  <div
    data-col={column}
    className={classNames(
      'text-white px-4 py-2 rounded-lg font-bold text-base flex items-center justify-between mb-4',
      `data-[col=1]:bg-[#ED6161]`,
      `data-[col=2]:bg-[#396AFF]`,
      `data-[col=3]:bg-[#F4CE38]`,
      `data-[col=4]:bg-[#16DB62]`,
      `data-[col=5]:bg-[#BEBEBE]`,
    )}
  >
    <span>{ label }</span>
    <span className="bg-white/30 px-2 py-0.5 rounded-full text-base">{ total }</span>
  </div>
)

const Card = ({ item, column, onReassign }) => {
  return (
    <div className="bg-white border border-gray5 rounded-xl p-2 shadow-sm mb-4">
      <h3 className="font-bold text-base text-black">{ item.user?.person?.fullName }</h3>
      <p className="text-sm text-default mb-4">{ item.address_reference }</p>
      <div className="flex justify-between items-center text-base mb-3">
        <span className="font-bold text-orange">{ item.vehicle?.plaque }</span>
        <span className="text-black text-sm font-semibold">🕒 { moment(item.date).format('h:mm') } <span className="text-default font-normal">{ moment(item.date).format('a') }</span></span>
      </div>
      <div
        data-col={column}
        className={classNames(
          'flex justify-between items-center font-bold text-sm px-2 py-1 rounded-md w-full',
          `data-[col=1]:bg-[#FFE9E9] data-[col=1]:text-[#ED6161]`,
          `data-[col=2]:bg-[#E7EDFF] data-[col=2]:text-[#396AFF]`,
          `data-[col=3]:bg-[#FFF9CA] data-[col=3]:text-[#F4CE38]`,
          `data-[col=4]:bg-[#EBFFFE] data-[col=4]:text-[#16DB62]`,
          `data-[col=5]:bg-[#F2F2F2] data-[col=5]:text-[#707070]`,
        )}
      >
        <span className="font-bold text-sm py-1.5 rounded-md uppercase">
          { item.status_text }
        </span>

        <Render condition={column === COLUMN.ALERT}>
          <button
            className="bg-[#ED6161] text-white text-sm font-semibold px-2 py-0.5 rounded-md"
            data-status={item.status}
            onClick={onReassign}
          >
            Reasignar
          </button>
        </Render>
      </div>
    </div>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    status: '',
    plaque: '',
    route: '',
  };

  const [data, setData] = useState({
    alerts: [],
    accepted: [],
    confirmed: [],
    initiated: [],
    finished: [],
    totals: {
      scheduled: 0,
      accepted: 0,
      initiated: 0,
      confirmed: 0,
      finished: 0,
      alerts: 0,
      kpi: 0,
    },
  });
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [selects] = useState({
    status: [
      { value: Constants.ORDER.STATUS.ACCEPTED, label: 'Aceptado' },
      { value: Constants.ORDER.STATUS.CONFIRMED, label: 'Confirmado' },
      { value: Constants.ORDER.STATUS.INITIATED, label: 'Iniciado' },
      { value: Constants.ORDER.STATUS.FINISHED, label: 'Finalizado' },
      { value: 99, label: 'En Alerta' },
    ],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    const groupData = (status, data) => {
      return data.filter(i => status.includes(i.status)) || [];
    }

    try {
      const payload = await getUpdatedState(setFilters);
      const res = await OrdersService.moderator.findAll(payload);

      const ST = Constants.ORDER.STATUS;

      const data = {
        alerts: groupData([ST.ALERT_REJECTED, ST.ALERT_UNACCEPTED, ST.ALERT_UNCONFIRMED, ST.ALERT_UNINITIATED], res.data),
        accepted: groupData([ST.ACCEPTED], res.data),
        confirmed: groupData([ST.CONFIRMED], res.data),
        initiated: groupData([ST.INITIATED], res.data),
        finished: groupData([ST.FINISHED], res.data),
        totals: res.totals,
      };

      setData(data);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const downloadAll = async () => {
    try {
      const response = await OrdersService.moderator.downloadAll(filters);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();

    // Activa los sockets necesarios
    Socket.on(SocketEvents.ROUTE.FLOW.PENDING, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.REJECTED, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.ACCEPTED, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.ALERT_UNACCEPTED, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.CONFIRMED, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.ALERT_UNCONFIRMED, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.INITIATED, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.ALERT_UNINITIATED, () => fetchData());
    Socket.on(SocketEvents.ROUTE.FLOW.FINISHED, () => fetchData());

    return () => {
      Socket.off(SocketEvents.ROUTE.FLOW.PENDING, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.REJECTED, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.ACCEPTED, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.ALERT_UNACCEPTED, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.CONFIRMED, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.ALERT_UNCONFIRMED, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.INITIATED, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.ALERT_UNINITIATED, () => fetchData());
      Socket.off(SocketEvents.ROUTE.FLOW.FINISHED, () => fetchData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data,
    downloadAll,
    filters,
    isLoading: !canFetch,
    onChange,
    reload,
    search: fetchData,
    selects,
  }
}

export default Panel;
